import React from "react";

const Blog = () => {
	return (
		<div>
			<h1 className="text-xl pt-10 text-center h-[100vh] text-blue-900">
				Blog is coming soon....
			</h1>
		</div>
	);
};

export default Blog;
